import React from "react";
import "./KeyFeatureComponent.css";
import Common_Enquiry_Form from "../../Common_Component/Common_Enquiry_Form/Common_Enquiry_Form";

const KeyFeatureComponent = () => {
  const data = [
    {
      title: "Simple Information Sharing",
      descn: "Share basic details online to help us understand your financial needs.",
      img: "/assets/Image/Home/feature/img1.png",
    },
    {
      title: " Guidance Through the Process ",
      descn: "Receive assistance throughout the application journey with our partner institutions.",
      img: "/assets/Image/Home/feature/img2.png",
    },
    {
      title: "Experienced Financial Consultants",
      descn: "Our team has extensive experience in financial facilitation and advisory services.",
      img: "/assets/Image/Home/feature/img3.png",
    },

    {
      title: "Clear & Transparent Process",
      descn: "We clearly explain applicable terms as shared by partner lenders.",
      img: "/assets/Image/Home/feature/img4.png",
    },

    {
      title: "Personalized Financial Guidance",
      descn: "Advice tailored to your profile and financial objectives.",
      img: "/assets/Image/Home/feature/img5.png",
    },
  ];

  return (
    <section className="KeyFeatureComponent">
      <div className="container">
        <div className="content_holder">
          <div className="row">
            <div className="col-lg-7">
              <div className="key_feature_main_div">
                <p className="section_heading">
                  Why Choose Profcyma Financial Solutions?
                </p>
                {/* <p className="sub_heading">
                  Special features only with our company
                </p> */}

                <div className="feature_outer_div">
                  {data?.map((item) => {
                    return (
                      <div className="feature_inner">
                        <div className="img_div">
                          <img src={item?.img} className="img" />
                        </div>

                        <div className="text_holder">
                          <p className="title">{item?.title}</p>
                          <p className="descn">{item?.descn}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="col-lg-5 custom_col">
              <div className="form_main_div">
                <Common_Enquiry_Form />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KeyFeatureComponent;
